export default __webpack_public_path__ + "static/client3-7bc79006a1b56120c3cc5bdcbca2146a.png";